




import VueOptions from '@utils/VueOptions'
import EventShow from '@modules/sponsor/components/Event/EventShow'

settings =
  name: 'EventShowPage'
  vue:
    components: { EventShow }

export default VueOptions.vue settings
